import Vue from 'vue';
import i18n from './i18n';

let interval = null
const userComp = new Vue({
  data() {
    return {
      vuetify: null,
      user: null,
    };
  },
  watch: {
    user(newValue, oldValue) {
      i18n.locale = newValue.language;

      try {
        // Onko legit?
        this.vuetify.framework.lang.current = newValue.language
      } catch (e) {
        console.error(e);
      }
    },
  },
});

export default userComp;
